import { render, staticRenderFns } from "./TuneDetector.vue?vue&type=template&id=86f6b8d8&scoped=true"
import script from "./TuneDetector.vue?vue&type=script&lang=js"
export * from "./TuneDetector.vue?vue&type=script&lang=js"
import style0 from "./TuneDetector.vue?vue&type=style&index=0&id=86f6b8d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f6b8d8",
  null
  
)

export default component.exports